import React, { memo } from "react";

import Icon from "../Icons/Icon";

function HawkeyeV2StaticFilter(props) {
  const { defaultFilter, openShowInfo } = props;

  if (defaultFilter != null) {
    return (
      <div key={defaultFilter.filterName} className={`hawkeye-filter-tag is-selected`}>
        <div className="hawkeye-filter-tag-name">{defaultFilter.filterName}</div>
        <button
          title="Show filter values"
          onClick={(e) => openShowInfo(defaultFilter, false)}
          className="hawkeye-action hawkeye-filter-tag-info"
        >
          <Icon icon="ICON_INFO" className="hawkeye-filter-tag-icon" />
        </button>
      </div>
    );
  } else {
    return null;
  }
}

export default memo(HawkeyeV2StaticFilter);
